import { BannerDTO } from '@/types/BannerDTO';
import { BannerItem } from '@/components/main/banner/BannerItem';
import { Grid, useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import React, { FC, ReactElement } from 'react';

interface Props {
  banners: BannerDTO[];
}

export const BannerContainer: FC<Props> = (props: Props): ReactElement => {
  const { banners } = props;

  const isMobile: boolean = useMediaQuery((theme: Theme): string => theme.breakpoints.down('sm'));

  return (
    <Grid container={true} direction={'column'} spacing={isMobile ? 1.5 : 2}>
      {(banners || []).map(
        (banner: BannerDTO): ReactElement => (
          <Grid item={true} key={banner.id}>
            <BannerItem banner={banner} />
          </Grid>
        ),
      )}
    </Grid>
  );
};
